<ng-template #appInfoDropdownTemplate>
  <div class="dropdown-content app-info">
    <img
      width="36"
      height="16"
      ngSrc="assets/img/pozi.svg"
      priority
      alt="Pozi logo"
    />
    <div class="section">
      <div>Frontend {{ build.version }}</div>
      <div>{{ build.buildDate | formatDate: 'yyyy.MM.dd HH:mm' }}</div>
    </div>
    <div class="section">
      <div>Backend {{ apiBuild.version }}</div>
      <div>{{ apiBuild.buildDate | formatDate: 'yyyy.MM.dd HH:mm' }}</div>
    </div>
  </div>
</ng-template>

<button
  class="app-info-trigger"
  poziOverlay
  [template]="appInfoDropdownTemplate"
  [trigger]="'click'"
>
  <i class="material-symbols-rounded">info</i>
</button>
